export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10791.7a8b1cff.jpg";